import React from "react";
import PropTypes from "prop-types";
import { HashRouter, NavLink } from "react-router-dom";
import Dashboard from "../../../../components/Dashboard";
import {
  PageHeight30,
  WizardTitle,
  notifyError,
  isProductDeleted,
} from "../../../../components/Utils";
import { FormMenu } from "../../../../components/Buttons";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { loadCard, cancelCard, saveCard } from "../../actions/cards";

import CardBasicDataForm from "../../components/CardBasicDataForm";
import MediaUploadForm from "../../../../components/MediaUploadForm";
// import CardTypeListForm from '../components/card/CardTypeListForm';

const frontload = async (props) => {
  const id = props.match.params.id;
  await props.getProduct({ id });
};
const mapStateToProps = (state) => {
  return {
    product: state.card.card,
  };
};
const mapDispatchToProps = (dispatch) => ({
  getProduct: (...args) => dispatch(loadCard(...args)),
  cancelProduct: (...args) => dispatch(cancelCard(...args)),
  saveProduct: (...args) => dispatch(saveCard(...args)),
});

class Wizard extends React.Component {
  static propTypes = {
    product: PropTypes.shape({}),
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    getProduct: PropTypes.func.isRequired,
    cancelProduct: PropTypes.func.isRequired,
    saveProduct: PropTypes.func.isRequired,
    className: PropTypes.string,
    cancelUrl: PropTypes.string,
  };
  static defaultProps = {
    className: "",
    cancelUrl: "/shop/karten/produkte",
  };
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillUnmount() {
    this.props.cancelProduct();
  }
  onCancel = () => {
    console.log("CardWizard.onCancel()");
    const { cancelProduct, history, cancelUrl } = this.props;
    cancelProduct();
    history.replace(cancelUrl);
  };
  onSave = () => {
    console.log("CardWizard.onSave()");
    const model = this.form.getModel();
    if (!model) {
      return notifyError({
        summary: "Produktverwaltung",
        detail: `Das Produkt konnte nicht gespeichert werden. Bitte Ihre Eingaben überprüfen.`,
      });
    }
    // product media
    let files = this.mediaForm.getModel();
    if (files && model.id) {
      files = files.media.map((item) => ({ ...item, product_id: model.id }));
    }
    model.files = files;

    console.log("Saving Model: ", model);
    const { history, saveProduct, cancelUrl } = this.props;
    const onSuccess = () => history.replace(cancelUrl);
    saveProduct(model, onSuccess);
  };
  renderMenu = () => {
    return (
      <div className="under-wizard-title">
        <HashRouter hashType="noslash">
          <div className="margin-big-top nav-menu-vertical">
            <ul className="w3-ul w3-border w3-round- w3-large">
              <li>
                <NavLink
                  to={`daten`}
                  className="disabled-link-"
                  activeClassName="active"
                >
                  {"Allgemeine Daten"}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={`medien`}
                  className="disabled-link-"
                  activeClassName="active"
                >
                  {"Bilder/Dateien"}
                </NavLink>
              </li>
            </ul>
          </div>
        </HashRouter>
      </div>
    );
  };
  render() {
    const { className, product } = this.props;
    console.log("CardWizard.render()", product);
    const Menu = this.renderMenu();
    if (!product) return null;
    const isDeleted = isProductDeleted(product);
    return (
      <div className={`card-order-wizard clearfix ${className}`}>
        <WizardTitle
          type="card"
          model={product}
          menu={
            <FormMenu
              className="pad-big-top"
              onSave={this.onSave}
              onCancel={this.onCancel}
              saveBtnName="saveCardBtn2"
              cancelBtnName="cancelCardBtn2"
              cancelBtnLabel={isDeleted ? "Schließen" : "Abbrechen"}
              saveHidden={isDeleted}
            />
          }
        />
        <div className="container">
          <Dashboard menu={Menu} menuSize={3}>
            <PageHeight30
              id="daten"
              className="w3-border margin-big-top pad-big"
              isUnterWizardTitle
            >
              <h3 className="no-margin-top">Allgemeine Daten</h3>
              <CardBasicDataForm
                ref={(ref) => (this.form = ref)}
                model={product}
              />
            </PageHeight30>
            <PageHeight30
              id="medien"
              className="w3-border margin-big-top pad-big"
              isUnterWizardTitle
            >
              <MediaUploadForm
                ref={(ref) => (this.mediaForm = ref)}
                title="Bilder/Dateien"
                model={product}
                readOnly={isDeleted}
              />
            </PageHeight30>
            <FormMenu
              className="w3-border margin-big-top pad-big w3-light-grey"
              onSave={this.onSave}
              onCancel={this.onCancel}
              saveBtnName="saveCardBtn"
              cancelBtnName="cancelCardBtn"
              cancelBtnLabel={isDeleted ? "Schließen" : "Abbrechen"}
              saveHidden={isDeleted}
            />
          </Dashboard>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(Wizard),
);
